import { Component, ElementRef, OnInit } from '@angular/core';
import { sortBy } from 'lodash';

import { AdminTitle } from '../../layout/AdminTitle';
import { AuthService } from 'tridion.web.ui/src/app/angular/login/adal/Auth.service';
import { BaseLiveStageCrudList } from '../../crud/list/BaseLiveStageCrudList';
import { ICrudData } from 'tridion.web.ui/src/app/angular/crud/ICrudData';
import { ISolrcore } from '../../model/product/ISolrcore';
import { FemcareSolrcoreApi } from '../../api/product/femcare/FemcareSolrcoreApi';
import { LiveStage } from '../../environment/LiveStage';
import { LiveStageService } from '../../environment/LiveStage.service';
import { ObjectIdCrud } from '../../crud/ObjectIdCrud';
import { PrettySubmitGuard } from 'tridion.web.ui/src/app/angular/save/PrettySubmitGuard';

@Component({
    templateUrl: '../BaseSolr.component.html',
    providers: [FemcareSolrcoreApi]
})
export class FemcareSolrComponent
    extends BaseLiveStageCrudList<
        ISolrcore,
        ICrudData<ISolrcore>,
        { liveStage: LiveStage }
    >
    implements OnInit {
    constructor(
        private adminTitle: AdminTitle,
        private authService: AuthService,
        private femcareSolrcoreApi: FemcareSolrcoreApi,
        elementRef: ElementRef,
        liveStageService: LiveStageService,
        prettySubmitGuard: PrettySubmitGuard
    ) {
        super(elementRef, 'product', liveStageService, prettySubmitGuard, 'Solr Core');
    }

    ngOnInit() {
        this.adminTitle.setTitle('Solr Cores - FemCare');

        this.filter.observable.subscribe(filter => {
            this.femcareSolrcoreApi.getAll().subscribe(cores => {
                this.init(sortBy(cores, 'core'));
            });
        });
    }

    protected createCrud() {
        return new ObjectIdCrud(this.femcareSolrcoreApi, this.authService);
    }
}
